const data = [
  {
    id: 1,
    image: "https://img.icons8.com/ios/40/000000/open-book.png",
    title: "Web Development",
    desc: "I develope web application using modern tech stacks. I use HTML5, CSS3 , Advanced javascript and react to make front-end of application and manage backend using MongoDB , NodeJs and Express",
  }
]
export default data
